module.exports = __webpack_public_path__ + "img/stopHostBg.8e49c878.png";